import React from 'react';
import { Route } from 'react-router-dom';
import AboutHome from '../pages/about/AboutHome';
import AboutPage from '../pages/about/AboutPage';
import ProtectedRoute from '../components/global/ProtectedRoute';

const aboutRoutes = (
    <>
        {/* About Home */}
        <Route
            path="/about-home"
            element={
                <ProtectedRoute requiredPermission="viewAny-about-home">
                    <AboutHome />
                </ProtectedRoute>
            }
        />

        {/* About Page */}
        <Route
            path="/about-page"
            element={
                <ProtectedRoute requiredPermission="viewAny-about-page">
                    <AboutPage />
                </ProtectedRoute>
            }
        />
    </>
);

export default aboutRoutes;
